import React from 'react'
import { Route, Switch } from 'react-router-dom'

import OrderRevenueExportList from './OrderRevenueExportList'

export default () => {
    return {
        routes: [
            {
                path: '/order-revenue-export',
                render: ({ match }) => (
                    <Switch>
                        <Route path={`${match.url}`} exact component={OrderRevenueExportList} />
                    </Switch>
                ),
            },
        ],
    }
}
